module.exports = __webpack_public_path__ + "img/times-radio.8f1f2123.png";